import { useEffect, useRef } from 'react';
import { metingenLopenUiteen, versieSleutel } from '../measurement-version';
import type { Meetversies } from '../work-quality.api';

/**
 * AD-24 — één meting per beeld: lopen de onderdelen uiteen, dan wordt het beeld opnieuw opgehaald.
 *
 * Een weergave die haar onderdelen in meerdere aanroepen ophaalt kan er twee lezingen tussen
 * krijgen; een beheerder die de drempel middenin verzet is genoeg. Het antwoord daarop is niet
 * "toon ze allebei" maar "haal het opnieuw op", want twee metingen naast elkaar zijn niet één beeld.
 *
 * Eén melding per samenstelling: gesorteerd en ontdubbeld, zodat dezelfde twee metingen in een
 * andere volgorde — twee aanroepen die naast elkaar terugkomen — niet opnieuw een herlading
 * uitlokken en er geen lus ontstaat.
 *
 * @returns true zolang de onderdelen uiteenlopen; de aanroeper toont dan geen cijfers.
 */
export function useEenMeting(onderdelen: readonly Meetversies[], onHerlaad: () => void): boolean {
  const lopenUiteen = metingenLopenUiteen(onderdelen);
  const sleutel = [...new Set(onderdelen.map(versieSleutel))].sort().join('|');
  const gemeld = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (!lopenUiteen || gemeld.current.has(sleutel)) return;
    gemeld.current.add(sleutel);
    onHerlaad();
  }, [lopenUiteen, sleutel, onHerlaad]);

  return lopenUiteen;
}
